import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useSuspensionInfo = (isSuspended: boolean) => {
  const query = useQuery({
    queryKey: [QueryKeys.SUSPENSION_INFO],
    queryFn: accountRepo.getSuspensionInfo,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: isSuspended,
  });

  return useQueryMemoized(query);
};

export type UseSuspensionInfo = ReturnType<typeof useSuspensionInfo>;
